import { useState } from "react";
import { api } from "../api";
import { when } from "../format";
import { Link } from "../router";
import type { Conversation } from "../types";

/**
 * The conversations, in the sidebar under the section nav on Cercetare.
 *
 * Each row is a link to /chat/:id, so a conversation can be opened in a new
 * tab or shared with whoever else can sign in to it - nobody, today, but the
 * URL is the address either way.
 */
export function ConversationList({
  conversations,
  activeId,
  onNew,
  onDeleted,
  onPicked,
}: {
  conversations: Conversation[];
  activeId: string | null;
  onNew: () => void;
  onDeleted: (id: string) => void;
  /** After a row is chosen - the mobile drawer closes itself on it. */
  onPicked?: () => void;
}) {
  // Two-step delete rather than a confirm() dialog: a modal would block the
  // page, and this is abandoned by clicking anywhere else.
  const [confirming, setConfirming] = useState<string | null>(null);

  async function remove(id: string) {
    await api.deleteConversation(id);
    setConfirming(null);
    onDeleted(id);
  }

  return (
    <>
      <span className="side-label">Conversații</span>
      <button className="newchat" onClick={onNew}>
        + Conversație nouă
      </button>
      {conversations.length === 0 && (
        <p className="convs-empty">Nicio conversație încă.</p>
      )}
      {conversations.map((c) => (
        <div
          key={c.id}
          className={c.id === activeId ? "conv on" : "conv"}
          onMouseLeave={() => confirming === c.id && setConfirming(null)}
        >
          <Link
            to={`/chat/${c.id}`}
            className="conv-main"
            aria-current={c.id === activeId ? "page" : undefined}
            onClick={onPicked}
          >
            <span className="t">{c.title}</span>
            <span className="m">{when(c.last_at)}</span>
          </Link>
          {confirming === c.id ? (
            <button className="conv-del confirm" onClick={() => void remove(c.id)}>
              Ștergeți?
            </button>
          ) : (
            <button
              className="conv-del"
              onClick={() => setConfirming(c.id)}
              aria-label={`Șterge conversația ${c.title}`}
              title="Șterge"
            >
              ×
            </button>
          )}
        </div>
      ))}
    </>
  );
}
